import React, { useState } from "react";
import DataTable from "react-data-table-component";
import Select from "react-select";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Tab,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import moment from "moment";
import ReactDatetime from "react-datetime";
import { Dna, Watch } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { getMarketing } from "stores";
import "./CabangKunjunganMarketing.css";

function ListKunjunganByGetMarketing(data) {
  // console.log(data, "KKKK");
  const dispatch = useDispatch();
  const kunjungan = useSelector((state) => state.kunjunganReducer);
  const auth = useSelector((state) => state.authReducer);
  const dataCabang = data.cabang;
  // console.log(dataCabang, "KKKK");

  const [isLoading, setIsLoading] = React.useState(true);
  const [tglAwal, setTglAwal] = React.useState(
    new Date(new Date().getFullYear(), new Date().getMonth(), 1).setHours(
      0,
      0,
      0,
      0
    )
  );
  const [tglAkhir, setTglAkhir] = React.useState(new Date());
  const [idCabang, setIdCabang] = React.useState("");
  const [idMarketing, setIdMarketing] = React.useState("");
  const [listDataMarketing, setListDataMarketing] = React.useState([]);
  const [listDataCabang, setListDataCabang] = React.useState([]);
  const [sendKunjunganMarketing, setSendKunjunganMarketing] = React.useState(
    []
  );
  const [currentPage, setCurrentPage] = React.useState(1);
  const itemsPerPage = 10;
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleClick = () => {
    dispatch({ type: "SET_DETAIL_KUNJUNGAN_MARKETING", data: true });
  };

  React.useEffect(() => {
    let tmp =
      data.data &&
      data.data.map((val) => {
        // console.log(val, "VALLL");
        return {
          ...val,
          cabang: data.cabang,
          action: (
            <>
              {" "}
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Detail</Tooltip>}
              >
                <Button
                  className="mr-0"
                  // variant="info"
                  style={{
                    marginTop: 5,
                    backgroundColor: "#F75D59",
                    border: 0,
                  }}
                  onClick={() => {
                    handleDetailsClick(val);
                  }}
                >
                  <i class="fas fa-info"></i>
                </Button>
              </OverlayTrigger>{" "}
            </>
          ),
        };
      });
    setListDataMarketing(tmp);
  }, [data.data]);

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];

  const getHasil = (hasilNasabah) => {
    switch (hasilNasabah) {
      case "Batal":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "Pinjam":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3EEF9",
          textColor: "#1569C7",
        };
      case "-":
        return {
          fontWeight: "bold",
          textColor: "#000000",
        };
      default:
        return {};
    }
  };

  const getKeputusan = (keputusan) => {
    switch (keputusan) {
      case "Tunda":
        return {
          fontWeight: "bold",
          backgroundColor: "#FFE6CC",
          textColor: "#FF7F00",
        };
      case "Batal":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "Disetujui":
        return {
          fontWeight: "bold",
          backgroundColor: "#E4F5C9",
          textColor: "#87CB16",
        };
      case "Ditolak":
        return {
          fontWeight: "bold",
          backgroundColor: "#FF0000",
          textColor: "#FFE6E6",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    rows: {
      style: {
        minHeight: "56px", // override the row height
        fontFamily: "Poppins, sans-serif",
      },
    },
    headRow: {
      style: {
        minHeight: "50px",
        backgroundColor: "#f8fafc",
        borderBottom: "2px solid #e2e8f0",
        fontFamily: "Poppins, sans-serif",
      },
    },
    headCells: {
      style: {
        fontWeight: "700",
        fontSize: "13px",
        color: "#475569",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        justifyContent: "center",
      },
    },
    cells: {
      style: {
        fontSize: "14px",
        color: "#334155",
        justifyContent: "center",
      },
    },
  };

  const colKunjungan = [
    {
      name: "No",
      width: "100px",
      center: true,
      selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
    },
    {
      name: "Nama Nasabah",
      minWidth: "250px",
      center: true,
      selector: (row) => row.calonNasabah.namaNasabah,
    },
    {
      name: "Tipe Kunjungan",
      minWidth: "250px",
      center: true,
      selector: (row) => row.calonNasabah.typeKunjungan,
    },
    {
      name: "Tgl Lahir",
      minWidth: "150px",
      center: true,
      selector: (row) =>
        moment(row.calonNasabah.tglLahir).format("DD MMMM YYYY"),
    },
    {
      name: "Cabang",
      minWidth: "250px",
      center: true,
      selector: (row) => row.cabang.namaCabang,
    },
    {
      name: "Tgl Kunjungan",
      minWidth: "150px",
      center: true,
      selector: (row) => moment(row.tglKunjungan).format("DD MMMM YYYY"),
    },
    {
      name: "Plafond",
      minWidth: "180px",
      center: true,
      selector: (row) => {
        const formattedValue = new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        }).format(row.plafond);
        return formattedValue;
      },
    },
    {
      name: "Nett",
      minWidth: "180px",
      center: true,
      selector: (row) => {
        const formattedValue = new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        }).format(row.nett);
        return formattedValue;
      },
    },
    {
      name: "Keputusan",
      minWidth: "200px",
      center: true,
      selector: (row) => row.keputusan,
      cell: (row) => {
        let badgeClass = "badge-neutral";
        if (row.keputusan === "Disetujui") badgeClass = "badge-disetujui";
        else if (row.keputusan === "Ditolak") badgeClass = "badge-ditolak";
        else if (row.keputusan === "Tunda") badgeClass = "badge-tunda";
        else if (row.keputusan === "Batal") badgeClass = "badge-batal";
        return (
          <span className={`modern-badge-pill ${badgeClass}`}>
            {row.keputusan || "-"}
          </span>
        );
      },
    },
    {
      name: "Hasil",
      minWidth: "200px",
      center: true,
      selector: (row) => row.hasil,
      cell: (row) => {
        const hasil =
          row.hasil === ""
            ? "-"
            : row.hasil === "Perhitungan minus"
            ? "Perhitungan Minus"
            : row.hasil;
        let badgeClass = "badge-neutral";
        if (hasil === "Batal") badgeClass = "badge-batal";
        else if (hasil === "Pinjam") badgeClass = "badge-pinjam";
        else if (hasil === "Perhitungan Minus") badgeClass = "badge-minus";
        return (
          <span className={`modern-badge-pill ${badgeClass}`}>
            {hasil}
          </span>
        );
      },
    },
  ];

  React.useEffect(() => {
    setIsLoading(true);
    getMarketing(dispatch, {
      tglAwal: moment(tglAwal).format("YYYY-MM-DD"),
      tglAkhir: moment(tglAkhir).format("YYYY-MM-DD"),
      idCabang: idCabang,
      idMarketing: idMarketing,
    })
      .then((response) => {
        // setLoading(false);
        setIsLoading(false);
      })
      .catch((error) => {
        // setLoading(false);
        setIsLoading(false);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [tglAwal, tglAkhir]);

  return (
    <>
      <Container fluid>
        <Button
          className="btn-back-custom"
          type="button"
          onClick={handleClick}
        >
          <i className="fas fa-arrow-left"></i>
        </Button>
        <Row>
          <Col md="12">
            <Card className="kunjungan-card">
              <Card.Header className="kunjungan-card-header">
                <Card.Title as="h3" className="kunjungan-title">
                  List Kunjungan Marketing
                </Card.Title>
                <p className="kunjungan-subtitle">
                  Detail riwayat kunjungan nasabah oleh marketing yang bersangkutan
                </p>
              </Card.Header>
              <Card.Body>
                <div className="date-filter-section">
                  <div className="date-filter-title">
                    <i className="fas fa-filter"></i> Filter Periode Kunjungan
                  </div>
                  <Row>
                    <Col xs={12} sm={6} md={4} lg={3} className="mb-3 mb-sm-0">
                      <label className="small font-weight-bold text-muted mb-1">
                        <i className="fas fa-calendar-alt mr-1"></i> Tanggal Awal
                      </label>
                      <ReactDatetime
                        inputProps={{
                          className: "form-control",
                          placeholder: "Pilih Tanggal",
                          readOnly: true,
                          style: {
                            cursor: "pointer",
                            color: "#334155",
                            backgroundColor: "#ffffff",
                            borderRadius: "8px",
                            border: "1px solid #cbd5e1"
                          },
                        }}
                        onChange={(e) => {
                          if (typeof e === "object" && e.toDate) {
                            e.toDate().setHours(0, 0, 0, 0);
                            setTglAwal(e.toDate().setHours(0, 0, 0, 0));
                          } else {
                            setTglAwal(e);
                          }
                        }}
                        value={tglAwal}
                        initialValue={tglAwal}
                        timeFormat={false}
                        closeOnSelect={true}
                      />
                    </Col>
                    <Col xs={12} sm={6} md={4} lg={3}>
                      <label className="small font-weight-bold text-muted mb-1">
                        <i className="fas fa-calendar-alt mr-1"></i> Tanggal Akhir
                      </label>
                      <ReactDatetime
                        inputProps={{
                          className: "form-control",
                          placeholder: "Pilih Tanggal",
                          readOnly: true,
                          style: {
                            cursor: "pointer",
                            color: "#334155",
                            backgroundColor: "#ffffff",
                            borderRadius: "8px",
                            border: "1px solid #cbd5e1"
                          },
                        }}
                        onChange={(e) => {
                          if (typeof e === "object" && e.toDate) {
                            e.toDate().setHours(0, 0, 0, 0);
                            setTglAkhir(e.toDate().setHours(0, 0, 0, 0));
                          } else {
                            setTglAkhir(e);
                          }
                        }}
                        value={tglAkhir}
                        initialValue={tglAkhir}
                        timeFormat={false}
                        closeOnSelect={true}
                      />
                    </Col>
                  </Row>
                </div>

                {isLoading ? (
                  <div className="loader-container">
                    <Watch
                      visible={true}
                      height="60"
                      width="60"
                      radius="30"
                      color="#F75D59"
                      ariaLabel="watch-loading"
                    />
                    <p>Memuat data kunjungan marketing...</p>
                  </div>
                ) : (
                  <div>
                    {listDataMarketing.length > 0 ? (
                      <DataTable
                        columns={colKunjungan}
                        data={listDataMarketing}
                        customStyles={customStyles}
                        pagination
                        paginationPerPage={itemsPerPage}
                        onChangePage={handlePageChange}
                      />
                    ) : (
                      <div className="text-center py-5">
                        <div className="alert alert-warning border-0 text-warning font-weight-bold mb-4 d-inline-block px-4" style={{ background: "#fffbeb", borderRadius: "8px" }}>
                          Maaf, belum ada kunjungan nasabah saat ini.
                        </div>
                        <img
                          src={require("assets/img/sorry.jpg")}
                          alt="Sorry"
                          style={{
                            maxWidth: "200px",
                            borderRadius: "8px",
                            display: "block",
                            margin: "0 auto",
                          }}
                        />
                      </div>
                    )}
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListKunjunganByGetMarketing;
